import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

const state = {
  companies: [],
  status: ''
}

const mutations = {
  REQUEST (state) {
    state.status = 'loading'
  },
  SUCCESS (state) {
    state.status = 'success'
  },
  ERROR (state, error) {
    state.status = 'error'
  },
  SET_COMPANIES (state, companies) {
    state.companies = companies
  },
  ADD_COMPANY (state, company) {
    state.companies.push(company)
  }
}

const actions = {
  getCompanies ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/company/list`)
        .then(response => {
          commit('SUCCESS')
          commit('SET_COMPANIES', response.data.companies)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  createCompany ({ commit }, company) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/company/create`, { company })
        .then(response => {
          commit('SUCCESS')
          commit('ADD_COMPANY', response.data.company)
          resolve(response.data.company)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
